import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAXbYin0wfn-KYCUH_dYWLag81GLtxx-Yw",
  authDomain: "typesync-18a8f.firebaseapp.com",
  databaseURL: "https://typesync-18a8f-default-rtdb.firebaseio.com",
  projectId: "typesync-18a8f",
  storageBucket: "typesync-18a8f.firebasestorage.app",
  messagingSenderId: "387117035670",
  appId: "1:387117035670:web:6cb6db1fcd2f19f20552b7",
  measurementId: "G-J608WH4Z6D"
};

// Log environment and configuration
console.log('🌐 Environment:', process.env.NODE_ENV);
console.log('🔥 Firebase Project ID:', firebaseConfig.projectId);
console.log('🔗 Database URL:', firebaseConfig.databaseURL);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

// Test database connection
try {
  console.log('🔌 Database initialized:', database.app.name);
} catch (error) {
  console.error('❌ Database initialization error:', error);
}

// Initialize Analytics
export const analytics = getAnalytics(app);

export default app;
